/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

import { createContext, useContext, useState } from 'react';

const Context = createContext({});

const OrdersContextProvider = ({ children }) => {

    const [paramsContext, setParamsContext] = useState(null)

    return (
        <Context.Provider value={{ paramsContext, setParamsContext }}>
            {children}
        </Context.Provider>
    );
};

const useOrdersContextProvider = () => {
    return useContext(Context);
};

export { OrdersContextProvider, useOrdersContextProvider };

